/**
 * 获得当前应用app名字
 * @returns
 */
export function getCurrentAppName() {
  return 'parent';
}
